<div #reportContainer id="reportContainer" style="width: 100%; height: 95vh;">
</div>
<footer class="footer-sidenav light-mode">
    <div class="footer-container">
        <div class="footer-content">
        © {{ currentYear }} RubiCube. All rights reserved
        </div>
    </div>
</footer>